import { Wording } from '@/types';

export const MEDITATION_WORDING_PL: Wording = {
  components_header_media_content: 'Audios',
  components_header_media_1: 'Medytacje',
  components_header_media_2: 'Podcast',
  components_header_text1: 'Przewodniki',
  components_header_text2: 'Blog',
  components_header_members: 'Członkowie',
  hero_text: 'Gdzie medytacja spotyka gwiazdy',
  hero_button_text: 'Rozpocznij swoją podróż do wewnątrz',
  components_ressources_section_title: 'ZASOBY',
  components_ressources_subheader_text: 'Narzędzia do wewnętrznego spokoju, uziemienia i codziennej równowagi',
  components_ressources_span_text: 'Otwórz drzwi do wewnętrznego spokoju dzięki naszym starannie dobranym medytacjom i przewodnikom. Znajdź jasność, połącz się ponownie ze swoim oddechem i dostosuj się do swojego wewnętrznego rytmu — jedna uważna chwila na raz.',
  components_ressources_card_1_title: 'Odbicie',
  components_ressources_card_1_text: 'Krótkie medytacje i refleksje audio pomagające skupić myśli i na nowo zsynchronizować się z rytmem kosmicznym.',
  components_ressources_card_2_title: 'Odkryj głębiny',
  components_ressources_card_2_text: 'Wyrusz w podróż poza powierzchnię z wciągającymi przewodnikami, którzy łączą medytację, astrologię i samopoznanie, co prowadzi do trwałej transformacji.',
  components_ressources_link: 'Zobacz więcej',
  components_notes_and_google_title_1: 'Duchowe przewodnictwo',
  components_notes_and_google_title_2: 'Rytuały uważności',
  components_notes_and_google_title_3: 'Medytacje z przewodnikiem',
  components_review_google_text: 'Recenzje Google',
  media_content_section_title: 'AUDIO',
  media_content_section_subheader_text: 'Nasze medytacje',
  text_media_1: '',
  text_media_2: '',
  media_content_section_button_more: 'Odkryj więcej',
  text2_section_title: 'BLOG',
  text2_section_subheader_text: '',
  text2_section_button_more: '',
  components_text1_section_title: 'PRZEWODNIKI',
  components_text1_subheader_text: 'Wiedza kosmiczna dla codziennego wyrównania',
  components_text1_span_text: 'Dostosuj się do rytmów wszechświata: zapoznaj się z starannie dobraną kolekcją dogłębnych przewodników astrologicznych i medytacyjnych, które mają na celu przebudzenie wewnętrznej jasności, pogłębienie samoświadomości i wsparcie Twojej podróży ku duchowemu, niebiańskiemu rozwojowi.',
  components_text1_card_1_title: 'Otwórz się na ciszę',
  components_text1_card_1_text: 'Rozpocznij swoją podróż z podstawowymi przewodnikami po medytacji i astrologii — idealnymi dla osób poszukujących wewnętrznego spokoju, wzorców kosmicznych i osobistego wglądu.',
  components_text1_card_3_title: 'Połączenie umysłu i ciała',
  components_text1_card_3_text: 'Odkryj głębsze warstwy swojego wewnętrznego świata. Te przewodniki wykraczają poza powierzchnię, aby ujawnić znaczenie, emocje i uważne wzorce, które kształtują twoje doświadczenie.',
  components_text1_card_2_title: 'Odbicie i integracja',
  components_text1_card_2_text: 'Od blokad emocjonalnych po cykle planetarne — przewodniki te oferują narzędzia do refleksji, uzdrawiania i transformacji poprzez uważne rytuały i mądrość astrologiczną.',
  components_text1_link: 'Zobacz wszystkie przewodniki',
  components_footer_text: 'Przebudź się w sobie: Twoja cisza, Twoja siła',
  components_footer_info: 'Informacje',
  components_footer_registration_number: 'Numer rejestracyjny',
  components_footer_legal: 'Prawny',
  components_footer_terms: 'Warunki i postanowienia',
  components_footer_privacy: 'Polityka prywatności',
  button_load_more: 'Załaduj więcej',
  page_media_1_content_hero_text: 'Medytacje',
  page_media_content_menu_antistress: 'Antystresowy',
  page_media_content_menu_mindfulness: 'Uważność',
  page_media_content_menu_energyboost: 'Zastrzyk energii',
  page_media_content_menu_mantra: 'Mantra',
  page_media_2_content_hero_text: '',
  page_text1_hero_text: 'Przewodniki',
  page_text1_section_title: 'Przewodniki',
  page_text1_subheader_text: 'Nasi przewodnicy',
  page_text2_hero_text: '',
  page_text2_section_title: '',
  page_text2_subheader_text: '',
  enter_email_title: 'Proszę wpisać swój adres e-mail, aby kontynuować',
  enter_email_placeholder_email: 'E-mail',
  enter_email_button_enter: 'Wchodzić',
  components_login_success_text: 'Logowanie pomyślne!',
  components_card_link_media_content: 'Słuchaj teraz',
  components_card_link_text1_content: 'Zobacz przewodnik',
  components_card_link_text2_content: 'Badać',
  france: 'Francja',
  cyprus: 'Cypr',
  tag_podcast: 'Podcast',
  tag_meditation: 'Medytacja',
  page_media_content_menu_all: 'Wszystko',
};